import * as React from "react";
import { Icon } from "../Icons/LucideIcons";
import { StyledActionButton } from "./__styles__/ActionButton";
import { type BaseButtonProps } from "./__styles__/BaseButton";

export type ActionButtonProps = Omit<BaseButtonProps, "children" | "isPending">;

export function ActionButton({
  "aria-label": ariaLabel = "more actions",
  ...props
}: ActionButtonProps) {
  return (
    <StyledActionButton {...props} aria-label={ariaLabel}>
      {({ isHovered, isDisabled }) => {
        return (
          <Icon
            aria-hidden={true}
            iconName="ellipsis"
            size={16}
            color={
              isDisabled ? "contentDisabled"
              : isHovered ?
                "contentPrimary"
              : "contentSecondary"
            }
          />
        );
      }}
    </StyledActionButton>
  );
}
